module.exports = __webpack_public_path__ + "80b3b8db42c2d059f5ca74f2b3143bfe.png";